import { gql } from '@apollo/client'

export const GET_MIGRANTS_INTERNAL_NOTES = gql`
  query GetMigrantsInternalNotes($document_id: Int) {
    getMigrantsInternalNotes(
      document_id: $document_id
    ) {
      id
      category_note
      document_id
      user_id
      text
      file_id
      type
      internal
      MigrantsInternalNotesToUser {
        id
        name
        charge
        id_role
        type_user
        JobPositionOfUser {
          id
          name
        }
      }
      fileInternal {
        id
        url
      }
      createdAt
      status_id
      InternalNotesToStatus {
        name
        description
        progress
        color
        order
      }
    }
  }
`

export const CREATE_MIGRANTS_INTERNAL_NOTE = gql`
  mutation CreateMigrantsInternalNote($inputMigrantInternalNote: migrantInternalNote!) {
    createMigrantsInternalNote(inputMigrantInternalNote: $inputMigrantInternalNote)
  }
`

export const EDIT_MIGRANTS_INTERNAL_NOTE = gql`
  mutation UpdateMigrantsInternalNote($id: Int!, $inputEditMessage: editMigrantsMessage!) {
    updateMigrantsInternalNote(id: $id, inputEditMessage: $inputEditMessage)
  }
`

export const DELETE_MIGRANTS_INTERNAL_NOTE = gql`
  mutation DeleteMigrantsInternalNote($id: Int!) {
    deleteMigrantsInternalNote(id: $id)
  }
`

export const NOTIFY_MIGRANTS_INTERNAL_NOTES_SUBSCRIPTION = gql`
  subscription NotifyMigrantsInternalNotesSuscription {
    notifyMigrantsInternalNotesSuscription {
      document_id
    }
  }
`
